import { put, call } from 'redux-saga/effects';
import api from '../../helpers/api';
import { countrySpecLoadSuccess, countrySpecLoadError } from './filter-actions';

export default function* filterSaga() {
    try {
        const countries = yield call(api.fetchData, 'countrySpecs');
        yield put(countrySpecLoadSuccess(countries));
    } catch (error) {
        yield put(countrySpecLoadError(true));
    }
}
